import React, {  useState, useEffect }  from 'react';
import './Funciones.css';

import imagenExpedienteBase from '../assets/Expediente_junio26.png';
import imagenRecetaMini from '../assets/personalizacion.png';
import imagenagendamientoBase from '../assets/Agenda_jun26.png';
import imagenIndicadoresBase from '../assets/Indicadores_jun26.png';

const imagenArchivosMini = null;


const Funciones = () => {
    
    const [activePremiumLayer, setActivePremiumLayer] = useState('expediente');
    const [activeAgendaLayer, setActiveAgendaLayer] = useState('agenda');
    const [activeIndicadoresLayer, setActiveIndicadoresLayer] = useState('dashboard');

useEffect(() => {
    const archivosTimer = setTimeout(() => {
        setActivePremiumLayer('archivos');
    }, 900);

    const finalTimer = setTimeout(() => {
        setActivePremiumLayer('final');
    }, 1800);

    return () => {
        clearTimeout(archivosTimer);
        clearTimeout(finalTimer);
    };
}, []);

useEffect(() => {
    const modalTimer = setTimeout(() => {
        setActiveAgendaLayer('modal');
    }, 900);

    const finalTimer = setTimeout(() => {
        setActiveAgendaLayer('final');
    }, 1800);

    return () => {
        clearTimeout(modalTimer);
        clearTimeout(finalTimer);
    };
}, []);

useEffect(() => {
    const actividadTimer = setTimeout(() => {
        setActiveIndicadoresLayer('actividad');
    }, 900);

    const finalTimer = setTimeout(() => {
        setActiveIndicadoresLayer('final');
    }, 1800);

    return () => {
        clearTimeout(actividadTimer);
        clearTimeout(finalTimer);
    };
}, []);

    
    return (
        <section id="features" className="funciones-section">
             <div className="funciones-header">
                
                <h1 className="funciones-title">
                    Todo lo que necesitas para <span>gestionar mejor tu consulta</span> sin pagar de más.
                </h1>
                <p className="funciones-subtitle">
                    Con Salvir tienes expediente, agenda e indicadores en un flujo
                    simple para ayudarte a trabajar con más orden, control y productividad.
                </p>
            </div>
                <div className={`funcion-item funcion-item-premium premium-active-${activePremiumLayer}`}>
                    <div className="funcion-premium-copy">
                        <h2>
                            Expediente clínico <span>completo</span>
                        </h2>

                        <p>
                            Toda la información de tus pacientes organizada en un solo lugar para darles
                            seguimiento completo y sin perder ningún detalle.
                        </p>

                         <ul className="expediente-feature-list">
                            <li>Historia clínica y seguimientos</li>
                            <li>Archivos y estudios adjuntos</li>
                            <li>Personaliza y exporta documentos</li>
                        </ul>
                    </div>

                    <div className="funcion-premium-visual">
                        <div className="premium-blob"></div>

                        <div className="premium-layer premium-layer-expediente">
                            <img
                                src={imagenExpedienteBase}
                                alt="Vista de expediente clínico completo"
                                className="premium-main-image"
                            />
                        </div>

                        <div className="premium-layer premium-layer-archivos">
                            {imagenArchivosMini ? (
                                <img
                                    src={imagenArchivosMini}
                                    alt="Archivos adjuntos del expediente"
                                    className="premium-floating-image"
                                />
                            ) : (
                                <div className="premium-files-card">
                                    <div className="premium-files-title">Archivos adjuntos</div>

                                    <div className="premium-file-row">
                                        <span className="premium-file-icon premium-file-pdf">PDF</span>
                                        <div>
                                            <strong>Resultados_laboratorio.pdf</strong>
                                            <small>245 KB</small>
                                        </div>
                                    </div>

                                    <div className="premium-file-row">
                                        <span className="premium-file-icon premium-file-png">PNG</span>
                                        <div>
                                            <strong>Imagen_estudios.png</strong>
                                            <small>1.2 MB</small>
                                        </div>
                                    </div>

                                    <div className="premium-file-row">
                                        <span className="premium-file-icon premium-file-doc">DOC</span>
                                        <div>
                                            <strong>Consentimiento_informado.docx</strong>
                                            <small>89 KB</small>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>

                        <div className="premium-layer premium-layer-receta">
                            
                            <img
                                src={imagenRecetaMini}
                                alt="Personalización de historia clínica y documentos"
                                className="premium-receta-image"
                            />
                        </div>
                    </div>
                </div>
                
                <div className={`funcion-item funcion-item-premium funcion-item-agenda premium-agenda-active-${activeAgendaLayer}`}>
                    <div className="funcion-agenda-visual">
                        <div className="agenda-blob"></div>

                        <div className="agenda-layer agenda-layer-calendario">
                            <img
                                src={imagenagendamientoBase}
                                alt="Agenda semanal de citas en Salvir"
                                className="agenda-main-image"
                            />
                        </div>

                        <div className="agenda-layer agenda-layer-modal">
                            <div className="agenda-modal-card">
                                <h3>Editar Cita</h3>

                               

                                <label>Paciente:</label>
                                <div className="agenda-input">Oswaldo Aguilar Padilla</div>

                                <button className="agenda-add-patient">
                                    Agregar Paciente
                                </button>

                                <div className="agenda-modal-grid">
                                    <div>
                                        <label>Fecha de Inicio:</label>
                                        <div className="agenda-input">  06/27/2026</div>
                                    </div>

                                    <div>
                                        <label>Hora de Inicio:</label>
                                        <div className="agenda-input">  01:30 PM</div>
                                    </div>

                                    <div>
                                        <label>Fecha de Fin:</label>
                                        <div className="agenda-input">  06/27/2026</div>
                                    </div>

                                    <div>
                                        <label>Hora de Fin:</label>
                                        <div className="agenda-input">      02:30 PM</div>
                                    </div>
                                </div>

                                <label>Motivo:</label>
                                <div className="agenda-input">Cefalea tensional</div>

                               

                                <div className="agenda-modal-actions">
                                    <span>Guardar</span>
                                    <span>Cancelar Cita</span>
                                    <span>Eliminar</span>
                                    <span>Atrás</span>
                                </div>
                            </div>
                        </div>

                        <div className="agenda-layer agenda-layer-recordatorios">
                            <div className="agenda-reminders-card">
                                <div className="agenda-reminder-row">
                                    <div className="agenda-reminder-icon">✓</div>
                                    <div>
                                        <strong>Confirmación de cita</strong>
                                        <small>Enviada</small>
                                    </div>
                                </div>

                                <div className="agenda-reminder-row">
                                    <div className="agenda-reminder-icon">🔔</div>
                                    <div>
                                        <strong>Recordatorio de cita</strong>
                                        
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="funcion-premium-copy funcion-agenda-copy">
                       

                        <h2>
                            Agendamiento de citas <span>eficiente</span>
                        </h2>

                        <p>
                            Organiza toda tu agenda en Salvir y mantén informados a tus pacientes
                            con confirmaciones y recordatorios por WhatsApp.
                        </p>

                        <ul className="agenda-feature-list">
                            <li>Vista semanal y diaria</li>
                            <li>Editar o cancelar citas</li>
                            <li>Confirmaciones y recordatorios por WhatsApp</li>
                        </ul>
                    </div>
                </div>
                
                <div className={`funcion-item funcion-item-premium funcion-item-indicadores premium-indicadores-active-${activeIndicadoresLayer}`}>
                    <div className="funcion-premium-copy funcion-indicadores-copy">
                     

                        <h2>
                            Controla y mejora tu práctica con <span>indicadores clave</span>
                        </h2>

                        <p>
                            Salvir te ayuda a monitorear lo que realmente importa: pacientes,
                            consultas, citas, recetas, ocupación y retención. Todo en un solo
                            lugar para tomar mejores decisiones y mejorar tu productividad.
                        </p>

                        <ul className="indicadores-feature-list">
                            <li>Registro y atención de pacientes</li>
                            <li>Actividad de consulta y agenda</li>
                            <li>Seguimiento y retención de pacientes</li>
                        </ul>
                    </div>

                    <div className="funcion-indicadores-visual">
                        <div className="indicadores-blob"></div>

                        <div className="indicadores-layer indicadores-layer-dashboard">
                            <img
                                src={imagenIndicadoresBase}
                                alt="Resumen de indicadores de la práctica médica"
                                className="indicadores-main-image"
                            />
                        </div>

                        <div className="indicadores-layer indicadores-layer-actividad">
                            <div className="indicadores-card indicadores-card-actividad">
                                <div className="indicadores-mini-card">
                                    <span>Consultas</span>
                                    <strong>2</strong>
                                    <small className="indicador-ok">● Vas mejor · +2</small>
                                </div>

                                <div className="indicadores-mini-card">
                                    <span>Citas con pacientes</span>
                                    <strong>7</strong>
                                    <small className="indicador-ok">● Vas mejor · +7</small>
                                </div>

                                <div className="indicadores-mini-card">
                                    <span>Recetas</span>
                                    <strong>6</strong>
                                   <small className="indicador-ok">● Vas mejor · +2</small>
                                </div>

                                <div className="indicadores-mini-card">
                                    <span>Ocupación de tu agenda</span>
                                    <strong>100%</strong>
                                    <small className="indicador-ok">● 23 de 23 hrs</small>
                                </div>
                            </div>
                        </div>

                        <div className="indicadores-layer indicadores-layer-retencion">
                            <div className="indicadores-card indicadores-card-retencion">
                                <div className="indicadores-mini-card">
                                    <span>Porcentaje de cancelación de citas</span>
                                    <strong>10%</strong>
                                   
                                </div>

                                <div className="indicadores-mini-card">
                                    <span>¿Regresan tus pacientes?</span>
                                    <strong>3 de cada 10</strong>
                                    
                                </div>

                                <div className="indicadores-mini-card">
                                    <span>Consultas por paciente</span>
                                    <strong>1.4 consultas</strong>
                                   
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
           
        </section>
    );
};

export default Funciones;